import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, finalize, tap } from "rxjs/operators";
import { EventService } from "../../shared/services/event.service";
import { StorageService } from "../../shared/services/storage.service";

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    
    constructor(private storageService: StorageService) {}



    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.method !== "GET") {
            return next.handle(req)
        }

        if(!req.headers.get("store-cache")) {
            this.storageService.cache.delete(req.urlWithParams)
            return next.handle(req)
        }

        const cacheKey = req.headers.get("store-cache")

        let headers = req.headers.delete("store-cache")
        req = req.clone({
            headers: headers
        });
        const cachedResponse: HttpResponse<any> = this.storageService.cache.get(cacheKey)

        if (cachedResponse) {
            return of(cachedResponse.clone())
        }
        return next.handle(req).pipe(
            tap<HttpEvent<any>>((httpEvent: HttpEvent<any>) => {
                if (httpEvent instanceof HttpResponse) {
                    this.storageService.cache.set(cacheKey, httpEvent.clone());

                }

                return httpEvent
            }), 
            catchError((err: HttpErrorResponse)=>{
                throw err;
            }),
            finalize(() => {
                
            })

        )
    }
}